import './styles.css';
import {
  usePlayerStore,
} from '../../stores/StoreContext';
import { View, Flex } from '@smarterservices/smarter-ui';
import WebrtcMedia from './Webrtc';
import HlsMedia from './Hls';
import { useMemo, memo } from 'react';
import Controls from './Controls';
import { useAppStore } from '../../stores/StoreContext';
import CONSTANTS from '../../config/constants';

const MemoizedWebrtcMedia = memo(WebrtcMedia);

const VideoPlayer = (props) => {
  const canHaveLiveVideo = usePlayerStore(
    (state) => state.canHaveLiveVideo
  );

  const sessionHeaderEnabled = useAppStore(
    (state) => state.enabledComponents.sessionHeader,
    (prev, next) => prev === next // Only re-render if the value changed
  );

  // Memoize WebrtcMedia - no dependencies means it only renders once
  const WebrtcMedia = useMemo(
    () => {
      return <MemoizedWebrtcMedia />
    },
    []
  );

  return (
    <>
      <Flex as="div" direction="column" height={sessionHeaderEnabled ? `calc(98% - ${CONSTANTS.HEADER_BAR.HEIGHT})` : '100%'}>
        <Flex.Item as="div" shouldGrow shouldShrink>
          <View
            as="div"
            overflow="hidden"
            width="100%"
            height="100%"
            padding="none x-small"
            className="hls-video-player-wrapper"
            style={{ overflow: 'hidden' }}
          >
            {canHaveLiveVideo && WebrtcMedia && WebrtcMedia}
            <HlsMedia />
          </View>
        </Flex.Item>
        <Flex.Item justifyContent="center" alignItems="center">
          <View
            as="div"
            overflow="hidden"
            width="100%"
            height="100%"
            padding="none small"
            style={{ overflow: 'hidden' }}
          >
            <Controls />
          </View>
        </Flex.Item>
      </Flex>
    </>
  );
};

export default VideoPlayer;
